export default __webpack_public_path__ + "static/media/fibra-optica.07f2a24d.png";